export const CURRENT_USER_REPO = 'CURRENT_USER_REPO';
export const CURRENT_USER_SERVICE = 'CURRENT_USER_SERVICE';